import { faBars } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React from "react";
import "./DropDown.scss";

function DropDownBtn({ open, openHandler }) {
  return (
    <button
      onClick={() => openHandler(!open)}
      className="btn burgerBtn"
      type="button"
    >
      <FontAwesomeIcon
        style={{
          fontSize: "22px",
          color: "white",
          backgroundColor: "transparent",
        }}
        icon={faBars}
      />
    </button>
  );
}

export default DropDownBtn;
